import React, { useState } from "react";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { akilDegerKaybiKaydet } from "../../lib/akilApi";

export default function AkilSaveDkButton({ kaydetAction, onSaved }) {
    const [loading, setLoading] = useState(false);
    if (!kaydetAction?.hesap) return null;

    const save = async () => {
        setLoading(true);
        try {
            const data = await akilDegerKaybiKaydet({
                dosya_no: kaydetAction.dosya_no,
                sigorta_dosyasi_id: kaydetAction.sigorta_dosyasi_id,
                hesap: kaydetAction.hesap,
            });
            if (!data.success) throw new Error(data.error);
            toast.success(`Değer kaybı kaydedildi: ${data.dosya_no || ""}`);
            onSaved?.(data);
        } catch (err) {
            toast.error(err.response?.data?.error || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            type="button"
            onClick={save}
            disabled={loading}
            className="mt-2 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600/80 hover:bg-emerald-600 text-white text-xs font-semibold disabled:opacity-50"
        >
            {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Save className="h-3.5 w-3.5" />}
            Dosyaya kaydet
        </button>
    );
}
